import apiClient from "./axios"

export const downloadAndOpenFile = async ({
  url,
  params = {},
  data = undefined,
  method = "get",
  mimeType = "application/pdf",
  openInNewTab = true,
  autoPrint = false,
  filename = null,
  onStart,
  onEnd,
}) => {
  try {
    onStart?.()

    const response = await apiClient({
      url,
      method,
      params,
      data,
      responseType: "blob",
    })

    const file = new Blob([response.data], { type: mimeType })
    const fileURL = URL.createObjectURL(file)

    if (autoPrint) {
      const iframe = document.createElement("iframe")
      iframe.style.position = "fixed"
      iframe.style.right = "0"
      iframe.style.bottom = "0"
      iframe.style.width = "0"
      iframe.style.height = "0"
      iframe.style.border = "0"
      iframe.src = fileURL
      document.body.appendChild(iframe)

      iframe.onload = () => {
        try {
          iframe.contentWindow.focus()
          iframe.contentWindow.print()
        } catch (err) {
          console.error("Auto print failed:", err)
        }
      }

      setTimeout(() => {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe)
        }
        URL.revokeObjectURL(fileURL)
      }, 60000)
    } else if (openInNewTab) {
      window.open(fileURL, "_blank")
      setTimeout(() => URL.revokeObjectURL(fileURL), 1000)
    } else {
      const link = document.createElement("a")
      link.href = fileURL
      link.download = filename || "download"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setTimeout(() => URL.revokeObjectURL(fileURL), 1000)
    }
  } catch (error) {
    console.error("File download/open failed:", error)
    throw error
  } finally {
    onEnd?.()
  }
}
